var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.701 8.89567C8.11128 8.89567 8.3277 9.38162 8.05324 9.68658L4.85226 13.2432C4.66401 13.4524 4.33603 13.4524 4.14778 13.2432L0.9468 9.68658C0.672336 9.38162 0.888759 8.89567 1.29904 8.89567H7.701Z",
    fill: "#8993A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.29904 5.10452C0.888759 5.10452 0.672335 4.61857 0.9468 4.31361L4.14778 0.756973C4.33603 0.547806 4.66401 0.547806 4.85226 0.756973L8.05324 4.31361C8.3277 4.61857 8.11128 5.10453 7.701 5.10453L1.29904 5.10452Z",
    fill: "#8993A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.6030375062a59e0118de7899da2d312b.svg";
export { ForwardRef as ReactComponent };